import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setAnsweringQuestionsAction } from "../../../../redux/answeringQuestions/answeringQuestions";

const EntryPopupHider = ( props ) => {

  const dispatch = useDispatch();
  const setAnsweringQuestions = payload => { dispatch( setAnsweringQuestionsAction( payload ) ) };

  useEffect( () => {
    const timer = setTimeout( hideEntryPopup, 2000 );
    return () => {
      clearTimeout( timer );
    };
  }, [] );

  const hideEntryPopup = () => {
    setAnsweringQuestions( { isShowEntryPopup : false } );
  };

  return props.children || null;

};

export default EntryPopupHider;
